// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__r3Ta2","main":"AppShell_main__p1V05","content":"AppShell_content__xDVOn","contentInner":"AppShell_contentInner__-hqfb","backdrop":"AppShell_backdrop__FFMVp"};